import {
  HttpErrorResponse,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { REDIRECT_ON_403 } from './auth-403.context';
import { AlertbarService } from '@core/services/snackbar/alert.service';

export const httpErrorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const alertbarService = inject(AlertbarService);
  const optedForRedirect = req.context.get(REDIRECT_ON_403);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
          if ((alertbarService as any).warn) {
            (alertbarService as any).warn(`Client error: ${error.error.message}`);
          }
          return throwError(() => error);
        }

        switch (error.status) {
          case 403:
            if (!optedForRedirect && (alertbarService as any).warn) {
              (alertbarService as any).warn('You don’t have permission to perform this action.');
            }
            break;
          case 400:
          case 404:
          case 500:
          case 503:
            break;
          default:
            break;
        }
      }
      return throwError(() => error);
    }),
  );
};